<template>
    <div class="file is-centered">
        <label class="file-label">
            <input
                :multiple="multiple"
                class="file-input"
                type="file"
                accept="image/*"
                @change="$emit('change', $event.target.files)"
            />
            <span class="file-cta">
                <span v-t="'creation.select_file'" class="file-label" />
            </span>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        multiple: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style></style>
